<template>
  <div v-if="noDescription" class="description_componenet">
    <div
      class="bg-white border-radius-8-px mt-1 p-10px"
      :class="{ 'ml-10px mr-5-px': clientWidth < 767 }"
    >
      <button @click="noDescription = false" class="add_description_button">
        {{ $t("PlaceHolder.Add_description") }}
      </button>
    </div>
  </div>
  <div class="editor-container description_componenet" v-show="!noDescription">
    <div
      v-show="contentLoaded"
      id="editorjs"
      :class="{
        'ml-10px mr-10-px': clientWidth < 767,
        show_hide_class: !isShow && props.from !== 'user',
      }"
      @click="isShow = true"
      @paste.capture="handleEditorPaste"
    ></div>
    <Transition>
      <span v-if="showMessage" class="saved_message">{{
        $t("Description.saved")
      }}</span>
    </Transition>
    <Skelaton
      class="w-100 border-radius-8-px"
      style="height: 60px"
      v-if="!contentLoaded"
    />
    <div v-show="false" id="editor-converter"></div>
    <div
      class="hide_show_wrapper"
      v-if="contentExceeds && props.from !== 'user'"
      :class="{ 'ml-10px mr-10-px': clientWidth < 767 }"
    >
      <button v-if="!isShow" @click="isShow = true" class="hide_show">
        {{ $t("Description.show_more") }}
      </button>
      <button v-else @click="isShow = false" class="hide_show">
        {{ $t("Description.show_less") }}
      </button>
    </div>
    <div
      class="d-flex justify-content-start description-action mt-10px mb-15px description-padding"
    >
      <!-- <button class="outline-primary mr-10px" @click="cancelData()">{{$t('Projects.cancel')}}</button> -->
      <button v-if="isChanged" class="btn-primary" @click="saveData()">
        {{ $t("Projects.save") }}
      </button>
    </div>

    <PromptSidebar
      v-if="isOpenPromptDeatil"
      @closePrompt="(isOpenPromptDeatil = false), resetAiBlocks()"
      :selectedPrompt="selectedPrompt"
      @closeMainSidebar="
        (e) => {
          isOpenPromptDeatil = false;
          e ? resetAiBlocks() : '';
        }
      "
      :project="project"
      :task="task"
    />
  </div>
</template>

<script setup>
import {
  computed,
  defineComponent,
  inject,
  onBeforeUnmount,
  onMounted,
  provide,
  ref,
  watch,
} from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import { useRoute, useRouter } from "vue-router";
import markdownit from "markdown-it";
import { useToast } from "vue-toast-notification";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const mardownInit = markdownit({
  html: true,
});
// mardownInit.renderer.rules.strong_open = () => "<b>";
// mardownInit.renderer.rules.strong_close = () => "</b>";

import PromptSidebar from "@/components/molecules/PromptSidebar/PromptSidebar.vue";

import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/nested-list";
import Checklist from "@editorjs/checklist";
import Marker from "@editorjs/marker";
import CodeTool from "@editorjs/code";
import InlineCode from "@editorjs/inline-code";
import Embed from "@editorjs/embed";
import Table from "@editorjs/table";
import writeWithAi from "./writeWithAi.js";

import { apiRequest } from "../../../services";
import * as env from "@/config/env";
import { useCustomComposable } from "@/composable";
import Skelaton from "@/components/atom/Skelaton/Skelaton.vue";
import taskClass from "@/utils/TaskOperations";
import { canUserEditKpiTask } from "@/utils/kpiTaskPermissions";
import { download } from "@/utils/StorageOprations/download";

defineComponent({
  name: "DescriptionComponent",
});
const { getters, commit } = useStore();

const currentCompany = computed(() => getters["settings/selectedCompany"]);
const showMessage = ref(false);
const isOpenPromptDeatil = ref(false);
const selectedPrompt = ref({});
const blockIndex = ref(null);
const router = useRouter();
const route = useRoute();
const isShow = ref(false);
const noDescription = ref(false);
const contentExceeds = ref(false);
const tempBlock = ref([]);
const isChanged = ref(false);
const emit = defineEmits(["updated", "add-file"]);

const contentLoaded = ref(false);

const { checkPermission, checkApps, debounce } = useCustomComposable();

const props = defineProps({
  description: {
    type: [String, Object],
    default: () => {},
  },
  editPermission: {
    type: [Boolean, Number],
    default: false,
  },
  minlength: {
    type: Number,
    default: 0,
  },
  isShowAi: {
    type: Boolean,
    default: false,
  },
  projectData: {
    type: Object,
    default: () => {},
  },
  from: {
    type: String,
    default: "",
  },
  task: {
    type: Object,
    default: () => {},
  },
  user: {
    type: Object,
    default: () => {},
  },
  note: {
    type: Object,
    default: () => {},
  },
});

const companyId = inject("$companyId");
const project = inject("selectedProject");
const clientWidth = inject("$clientWidth");

const checkAiProject = computed(() => checkApps("AI", props.projectData));
const checkAiDescription =
  props.from === "project"
    ? computed(() =>
        checkPermission(
          "project.project_description",
          props.projectData?.isGlobalPermission,
          { gettersVal: getters }
        )
      )
    : computed(() =>
        checkPermission(
          "task.task_description",
          props.projectData?.isGlobalPermission,
          { gettersVal: getters }
        )
      );

class NoteFileTool {
  constructor({ data, api, config, readOnly }) {
    this.data = data || {};
    this.api = api;
    this.config = config || {};
    this.readOnly = Boolean(readOnly);
  }

  static get isReadOnlySupported() {
    return true;
  }

  static get toolbox() {
    return {
      title: "File",
      icon: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V7L14 2Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M14 2V7H19" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9 13H15M9 17H13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    };
  }

  render() {
    if (Object.keys(this.data || {}).length) {
      const rawFileUrl =
        this.data.cdnUrl ||
        this.data.url ||
        this.data.link ||
        this.data.href ||
        "";
      const fileUrl =
        rawFileUrl && /^https?:\/\//i.test(rawFileUrl) ? rawFileUrl : "";
      const holder = document.createElement("button");
      holder.type = "button";
      holder.style.display = "flex";
      holder.style.alignItems = "center";
      holder.style.gap = "10px";
      holder.style.width = "100%";
      holder.style.maxWidth = "430px";
      holder.style.padding = "10px 12px";
      holder.style.margin = "6px 0";
      holder.style.border = "1px solid #E5EAF1";
      holder.style.borderRadius = "8px";
      holder.style.background = "#F8FAFC";
      holder.style.color = "#1F2937";
      holder.style.cursor = "pointer";
      holder.style.textAlign = "left";
      holder.innerHTML = `
                <span style="display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:6px;background:#EAF4FF;color:#006FE6;flex:0 0 auto;">
                    ${NoteFileTool.toolbox.icon}
                </span>
                <span style="display:flex;flex-direction:column;min-width:0;">
                    <span style="font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${
                      this.data.name || "File"
                    }</span>
                    <span style="font-size:12px;color:#8A94A6;">${this.formatFileSize(
                      this.data.size
                    )}</span>
                </span>
            `;
      holder.addEventListener("click", () => {
        if (fileUrl) {
          if (this.shouldDownloadOnClick()) {
            download(fileUrl, this.data.name || "download");
            return;
          }
          window.open(fileUrl, "_blank", "noopener");
        }
      });
      return holder;
    }

    const holder = document.createElement("div");
    holder.style.display = "flex";
    holder.style.alignItems = "center";
    holder.style.gap = "10px";
    holder.style.width = "100%";
    holder.style.maxWidth = "430px";
    holder.style.padding = "10px 12px";
    holder.style.margin = "6px 0";
    holder.style.border = "1px dashed #CDE3FF";
    holder.style.borderRadius = "8px";
    holder.style.background = "#F8FAFC";
    holder.style.color = "#006FE6";
    holder.style.cursor = this.readOnly ? "default" : "pointer";
    holder.innerHTML = `
            <span style="display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:6px;background:#EAF4FF;color:#006FE6;flex:0 0 auto;">
                ${NoteFileTool.toolbox.icon}
            </span>
            <span style="font-weight:500;">${
              this.readOnly ? "File unavailable" : "Choose file"
            }</span>
        `;
    if (this.readOnly) return holder;

    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.style.display = "none";
    input.addEventListener("change", () => {
      const files = Array.from(input.files || []);
      if (files.length) {
        this.config.onSelect?.(files);
      }
      const currentIndex = this.api.blocks.getCurrentBlockIndex();
      if (currentIndex >= 0) {
        this.api.blocks.delete(currentIndex);
      }
    });
    holder.appendChild(input);
    holder.addEventListener("click", () => input.click());
    return holder;
  }

  save() {
    return this.data;
  }

  formatFileSize(size = 0) {
    const bytes = Number(size) || 0;
    if (!bytes) return "";
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }

  shouldDownloadOnClick() {
    const extension = (
      this.data.extension ||
      this.data.name?.split(".").pop() ||
      ""
    ).toLowerCase();
    return ["rar", "zip", "7z", "tar", "gz"].includes(extension);
  }
}

class NoteImageTool {
  constructor({ data, api, config, readOnly }) {
    this.data = data || {};
    this.api = api;
    this.config = config || {};
    this.readOnly = Boolean(readOnly);
  }

  static get isReadOnlySupported() {
    return true;
  }

  static get toolbox() {
    return {
      title: "Image",
      icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="2.5" y="3.5" width="15" height="13" rx="2" stroke="currentColor" stroke-width="1.5"/><circle cx="7" cy="8" r="1.5" fill="currentColor"/><path d="M4.5 14L8.5 10L11 12L13.5 9.5L16 12.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    };
  }

  render() {
    const source = this.data.cdnUrl || this.data.url || "";
    if (!source) return this.renderPicker();
    const figure = document.createElement("figure");
    const initialWidth = Math.min(
      100,
      Math.max(20, Number(this.data.width) || 40)
    );
    figure.style.margin = "8px 0";
    figure.style.position = "relative";
    figure.style.width = `${initialWidth}%`;
    figure.style.maxWidth = "100%";
    const image = document.createElement("img");
    image.src = source;
    image.alt = this.data.name || "Pasted image";
    image.style.display = "block";
    image.style.width = "100%";
    image.style.maxWidth = "100%";
    image.style.maxHeight = "560px";
    image.style.borderRadius = "8px";
    image.style.objectFit = "contain";
    image.style.cursor = "zoom-in";
    image.addEventListener("click", () =>
      this.openPreview(image.src, image.alt)
    );

    const leftHandle = this.createResizeHandle("left");
    const rightHandle = this.createResizeHandle("right");
    const handles = [leftHandle, rightHandle];

    const startResize = (event, side) => {
      event.preventDefault();
      event.stopPropagation();
      const parentWidth =
        figure.parentElement?.clientWidth ||
        figure.getBoundingClientRect().width;
      const startX = event.clientX;
      const startWidth = figure.getBoundingClientRect().width;
      const blockId = figure.closest(".ce-block")?.dataset?.id;
      const blockIndex = blockId
        ? this.api?.blocks?.getBlockIndex?.(blockId)
        : this.api?.blocks?.getCurrentBlockIndex?.();
      let hasMoved = false;

      const resize = (moveEvent) => {
        const delta = (moveEvent.clientX - startX) * (side === "left" ? -1 : 1);
        if (Math.abs(delta) > 1) hasMoved = true;
        const nextWidth = Math.min(
          parentWidth,
          Math.max(parentWidth * 0.2, startWidth + delta)
        );
        const nextPercent = Math.round((nextWidth / parentWidth) * 100);
        this.data.width = nextPercent;
        figure.style.width = `${nextPercent}%`;
      };

      const stopResize = () => {
        document.removeEventListener("pointermove", resize);
        document.removeEventListener("pointerup", stopResize);
        document.body.style.userSelect = "";
        document.body.style.cursor = "";
        if (hasMoved && Number.isInteger(blockIndex) && blockIndex >= 0) {
          this.api?.blocks?.getBlockByIndex?.(blockIndex)?.dispatchChange?.();
        }
        if (hasMoved) this.config.onResize?.(this.data.width);
      };

      document.body.style.userSelect = "none";
      document.body.style.cursor = "ew-resize";
      document.addEventListener("pointermove", resize);
      document.addEventListener("pointerup", stopResize);
    };

    leftHandle.addEventListener("pointerdown", (event) =>
      startResize(event, "left")
    );
    rightHandle.addEventListener("pointerdown", (event) =>
      startResize(event, "right")
    );

    figure.addEventListener("mouseenter", () => {
      handles.forEach((handle) => {
        handle.style.opacity = "1";
      });
    });
    figure.addEventListener("mouseleave", () => {
      if (document.body.style.cursor !== "ew-resize") {
        handles.forEach((handle) => {
          handle.style.opacity = "0";
        });
      }
    });
    figure.appendChild(image);
    figure.append(leftHandle, rightHandle);
    return figure;
  }

  renderPicker() {
    const holder = document.createElement("button");
    holder.type = "button";
    holder.className = "note-media-picker";
    holder.innerHTML = `<span>▧</span><strong>${
      this.readOnly ? "Image unavailable" : "Choose image"
    }</strong>`;
    if (this.readOnly) return holder;
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.style.display = "none";
    input.addEventListener("change", () => {
      const files = Array.from(input.files || []);
      if (files.length) this.config.onSelect?.(files);
      const index = this.api.blocks.getCurrentBlockIndex();
      if (index >= 0) this.api.blocks.delete(index);
    });
    holder.appendChild(input);
    holder.addEventListener("click", () => input.click());
    return holder;
  }

  createResizeHandle(side) {
    const handle = document.createElement("div");
    handle.style.position = "absolute";
    handle.style.top = "50%";
    handle.style[side] = "-18px";
    handle.style.width = "7px";
    handle.style.height = "44px";
    handle.style.borderRadius = "999px";
    handle.style.background = "rgba(15, 23, 42, 0.62)";
    handle.style.boxShadow = "0 1px 4px rgba(15, 23, 42, 0.18)";
    handle.style.cursor = "ew-resize";
    handle.style.opacity = "0";
    handle.style.transform = "translateY(-50%)";
    handle.style.transition = "opacity 0.15s ease";
    handle.style.touchAction = "none";
    handle.style.zIndex = "2";
    return handle;
  }

  openPreview(src, alt) {
    if (!src) return;
    const overlay = document.createElement("div");
    overlay.style.position = "fixed";
    overlay.style.inset = "0";
    overlay.style.zIndex = "100000";
    overlay.style.display = "flex";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.padding = "32px";
    overlay.style.background = "rgba(15, 23, 42, 0.82)";
    overlay.style.cursor = "zoom-out";

    const preview = document.createElement("img");
    preview.src = src;
    preview.alt = alt;
    preview.style.maxWidth = "92vw";
    preview.style.maxHeight = "90vh";
    preview.style.objectFit = "contain";
    preview.style.borderRadius = "10px";
    preview.style.boxShadow = "0 24px 60px rgba(0, 0, 0, 0.35)";
    overlay.appendChild(preview);

    const close = () => {
      document.removeEventListener("keydown", onKeydown);
      overlay.remove();
    };
    const onKeydown = (event) => {
      if (event.key === "Escape") close();
    };
    overlay.addEventListener("click", close);
    preview.addEventListener("click", (event) => event.stopPropagation());
    document.addEventListener("keydown", onKeydown);
    document.body.appendChild(overlay);
  }

  save() {
    return this.data;
  }
}

const mediaToolIcon = (kind) =>
  ({
    video:
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="2.5" y="4" width="15" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="M8 7.5L13 10L8 12.5V7.5Z" fill="currentColor"/></svg>',
    audio:
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3 8H6L10 4V16L6 12H3V8Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M13 7C14.4 8.5 14.4 11.5 13 13M15.5 4.5C18.5 7.5 18.5 12.5 15.5 15.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
  }[kind]);

const createNoteMediaTool = (kind, title, accept) =>
  class {
    constructor({ data, api, config, readOnly }) {
      this.data = data || {};
      this.api = api;
      this.config = config || {};
      this.readOnly = Boolean(readOnly);
    }

    static get toolbox() {
      return { title, icon: mediaToolIcon(kind) };
    }

    static get isReadOnlySupported() {
      return true;
    }

    render() {
      const source = this.data.cdnUrl || this.data.url || "";
      if (!source) return this.renderPicker();
      const holder = document.createElement("div");
      holder.className = `note-${kind}-block`;
      const media = document.createElement(kind);
      media.src = source;
      media.controls = true;
      media.preload = "metadata";
      holder.appendChild(media);
      if (this.data.name) {
        const caption = document.createElement("small");
        caption.textContent = this.data.name;
        holder.appendChild(caption);
      }
      return holder;
    }

    renderPicker() {
      const holder = document.createElement("button");
      holder.type = "button";
      holder.className = "note-media-picker";
      holder.innerHTML = `<span>${kind === "video" ? "▶" : "◖"}</span><strong>${
        this.readOnly ? `${title} unavailable` : `Choose ${title.toLowerCase()}`
      }</strong>`;
      if (this.readOnly) return holder;
      const input = document.createElement("input");
      input.type = "file";
      input.accept = accept;
      input.style.display = "none";
      input.addEventListener("change", () => {
        const files = Array.from(input.files || []);
        if (files.length) this.config.onSelect?.(files);
        const index = this.api.blocks.getCurrentBlockIndex();
        if (index >= 0) this.api.blocks.delete(index);
      });
      holder.appendChild(input);
      holder.addEventListener("click", () => input.click());
      return holder;
    }

    save() {
      return this.data;
    }
  };

const NoteVideoTool = createNoteMediaTool("video", "Video", "video/*");
const NoteAudioTool = createNoteMediaTool("audio", "Audio", "audio/*");

let noteToolboxObserver;
function setupNoteToolboxSections() {
  if (props.from !== "user") return;
  const root = document
    .getElementById("editorjs")
    ?.closest(".editor-container");
  if (!root) return;

  const decorate = () => {
    root.querySelectorAll(".ce-popover__items").forEach((items) => {
      if (items.dataset.noteGrouped === "true") return;
      const mediaItem = items.querySelector('[data-item-name="image"]');
      if (!mediaItem) return;
      const basicLabel = document.createElement("div");
      basicLabel.className = "note-toolbox-section";
      basicLabel.textContent = "Basic blocks";
      const mediaLabel = document.createElement("div");
      mediaLabel.className = "note-toolbox-section";
      mediaLabel.textContent = "Media";
      items.prepend(basicLabel);
      mediaItem.before(mediaLabel);
      items.dataset.noteGrouped = "true";
    });
  };

  noteToolboxObserver?.disconnect();
  noteToolboxObserver = new MutationObserver(decorate);
  noteToolboxObserver.observe(root, { childList: true, subtree: true });
  decorate();
}

function handleEditorPaste(event) {
  if (props.from !== "user" || !props.editPermission) return;
  const imageFiles = Array.from(event.clipboardData?.items || [])
    .filter((item) => item.kind === "file" && item.type?.startsWith("image/"))
    .map((item) => item.getAsFile())
    .filter(Boolean)
    .map((file) =>
      file.name
        ? file
        : new File(
            [file],
            `pasted-image-${Date.now()}.${file.type.split("/")[1] || "png"}`,
            { type: file.type }
          )
    );

  if (!imageFiles.length) return;
  event.preventDefault();
  emit("add-file", imageFiles);
}

const headingToolIcon = (level) => `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 4V16M3 10H10M10 4V16" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <text x="13" y="15" fill="currentColor" font-size="9" font-family="Arial, sans-serif" font-weight="700">${level}</text>
    </svg>`;

const listToolIcon = (ordered) =>
  ordered
    ? '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><text x="2" y="8" fill="currentColor" font-size="7" font-family="Arial">1.</text><text x="2" y="16" fill="currentColor" font-size="7" font-family="Arial">2.</text><path d="M9 6H18M9 14H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
    : '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="6" r="1.4" fill="currentColor"/><circle cx="4" cy="14" r="1.4" fill="currentColor"/><path d="M9 6H18M9 14H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

const noteBlockIcons = {
  toggle:
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4 5.5L8 9.5L4 13.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 6H18M10 10H18M10 14H18" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
  page: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 2.5H12L16 6.5V17.5H5V2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M12 2.5V6.5H16M8 10H13M8 13H13" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
  callout:
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="2.5" y="3" width="15" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="M6 7.5H14M6 11H12.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
  quote:
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3 13C3 9.5 4.2 6.8 7.2 5L8.2 6.5C6.5 7.6 5.8 9 5.7 10.2H8.5V15H3V13ZM11 13C11 9.5 12.2 6.8 15.2 5L16.2 6.5C14.5 7.6 13.8 9 13.7 10.2H16.5V15H11V13Z" fill="currentColor"/></svg>',
  divider:
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2 10H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
};

class NoteToggleTool {
  constructor({ data, readOnly }) {
    this.data = data || {};
    this.readOnly = Boolean(readOnly);
  }

  static get toolbox() {
    return { title: "Toggle list", icon: noteBlockIcons.toggle };
  }

  static get isReadOnlySupported() {
    return true;
  }

  render() {
    this.wrapper = document.createElement("details");
    this.wrapper.className = "note-toggle-block";
    this.wrapper.open = this.data.open !== false;
    this.summary = document.createElement("summary");
    this.summary.contentEditable = this.readOnly ? "false" : "true";
    this.summary.dataset.placeholder = "Tiêu đề toggle";
    this.summary.innerHTML = this.data.title || "";
    this.content = document.createElement("div");
    this.content.className = "note-toggle-content";
    this.content.contentEditable = this.readOnly ? "false" : "true";
    this.content.dataset.placeholder = "Nhập nội dung...";
    this.content.innerHTML = this.data.content || "";
    this.wrapper.append(this.summary, this.content);
    return this.wrapper;
  }

  save() {
    return {
      title: this.summary?.innerHTML || "",
      content: this.content?.innerHTML || "",
      open: Boolean(this.wrapper?.open),
    };
  }
}

class NotePageTool {
  constructor({ data, readOnly }) {
    this.data = data || {};
    this.readOnly = Boolean(readOnly);
  }

  static get toolbox() {
    return { title: "Page", icon: noteBlockIcons.page };
  }

  static get isReadOnlySupported() {
    return true;
  }

  render() {
    this.wrapper = document.createElement("div");
    this.wrapper.className = "note-page-block";
    const icon = document.createElement("span");
    icon.innerHTML = noteBlockIcons.page;
    this.title = document.createElement("div");
    this.title.contentEditable = this.readOnly ? "false" : "true";
    this.title.dataset.placeholder = "Tên trang";
    this.title.innerHTML = this.data.title || "";
    this.wrapper.append(icon, this.title);
    return this.wrapper;
  }

  save() {
    return { title: this.title?.innerHTML || "" };
  }
}

class NoteCalloutTool {
  constructor({ data, readOnly }) {
    this.data = data || {};
    this.readOnly = Boolean(readOnly);
  }

  static get toolbox() {
    return { title: "Callout", icon: noteBlockIcons.callout };
  }

  static get isReadOnlySupported() {
    return true;
  }

  render() {
    this.wrapper = document.createElement("div");
    this.wrapper.className = "note-callout-block";
    const icon = document.createElement("span");
    icon.textContent = this.data.icon || "💡";
    this.content = document.createElement("div");
    this.content.contentEditable = this.readOnly ? "false" : "true";
    this.content.dataset.placeholder = "Nhập nội dung nổi bật...";
    this.content.innerHTML = this.data.text || "";
    this.wrapper.append(icon, this.content);
    return this.wrapper;
  }

  save() {
    return { icon: "💡", text: this.content?.innerHTML || "" };
  }
}

class NoteQuoteTool {
  constructor({ data, readOnly }) {
    this.data = data || {};
    this.readOnly = Boolean(readOnly);
  }

  static get toolbox() {
    return { title: "Quote", icon: noteBlockIcons.quote };
  }

  static get isReadOnlySupported() {
    return true;
  }

  render() {
    this.wrapper = document.createElement("blockquote");
    this.wrapper.className = "note-quote-block";
    this.wrapper.contentEditable = this.readOnly ? "false" : "true";
    this.wrapper.dataset.placeholder = "Nhập trích dẫn...";
    this.wrapper.innerHTML = this.data.text || "";
    return this.wrapper;
  }

  save() {
    return { text: this.wrapper?.innerHTML || "" };
  }
}

class NoteDividerTool {
  static get toolbox() {
    return { title: "Divider", icon: noteBlockIcons.divider };
  }

  static get isReadOnlySupported() {
    return true;
  }

  render() {
    const holder = document.createElement("div");
    holder.className = "note-divider-block";
    holder.appendChild(document.createElement("hr"));
    return holder;
  }

  save() {
    return {};
  }
}

function getEditorTools(includeNoteFile = false) {
  const tools = {
    WriteWithAi: {
      class: writeWithAi,
      config: {
        openSidebar: openDescriptionWithAi,
        isShowAi: checkAiProject.value && checkAiDescription.value,
      },
    },
    header: {
      class: Header,
      inlineToolbar: true,
    },
    list: {
      class: List,
      inlineToolbar: true,
    },
    checklist: {
      class: Checklist,
      inlineToolbar: true,
    },
    marker: {
      class: Marker,
      inlineToolbar: true,
    },
    code: {
      class: CodeTool,
      inlineToolbar: true,
    },
    inlineCode: {
      class: InlineCode,
      inlineToolbar: true,
    },
    embed: {
      class: Embed,
      inlineToolbar: true,
    },
    table: {
      class: Table,
      inlineToolbar: true,
    },
  };

  if (includeNoteFile) {
    tools.paragraph = { config: { preserveBlank: true } };
    tools.code.toolbox = false;
    tools.embed.toolbox = false;
    tools.header.config = {
      levels: [1, 2, 3, 4],
      defaultLevel: 2,
    };
    tools.header.toolbox = [1, 2, 3, 4].map((level) => ({
      title: `Heading ${level}`,
      icon: headingToolIcon(level),
      data: { level },
    }));
    tools.list.toolbox = [
      {
        title: "Bulleted list",
        icon: listToolIcon(false),
        data: { style: "unordered", items: [] },
      },
      {
        title: "Numbered list",
        icon: listToolIcon(true),
        data: { style: "ordered", items: [] },
      },
    ];
    tools.checklist.toolbox = {
      title: "To-do list",
      icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="2.5" y="3" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.4"/><path d="M4 5.5L5 6.5L6.5 4.5M10 5.5H18" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><rect x="2.5" y="12" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.4"/><path d="M10 14.5H18" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
    };
    tools.toggle = {
      class: NoteToggleTool,
      inlineToolbar: true,
    };
    tools.page = {
      class: NotePageTool,
      inlineToolbar: true,
    };
    tools.callout = {
      class: NoteCalloutTool,
      inlineToolbar: true,
    };
    tools.quote = {
      class: NoteQuoteTool,
      inlineToolbar: true,
    };
    tools.table.toolbox = {
      title: "Table",
      icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="2.5" y="3.5" width="15" height="13" rx="1.5" stroke="currentColor" stroke-width="1.4"/><path d="M2.5 8H17.5M2.5 12.5H17.5M8 3.5V16.5M13 3.5V16.5" stroke="currentColor" stroke-width="1.1"/></svg>',
    };
    tools.divider = {
      class: NoteDividerTool,
    };
    tools.image = {
      class: NoteImageTool,
      config: {
        onResize: () => saveData(),
        onSelect: (files) => emit("add-file", files),
      },
    };
    tools.video = {
      class: NoteVideoTool,
      config: {
        onSelect: (files) => emit("add-file", files),
      },
    };
    tools.audio = {
      class: NoteAudioTool,
      config: {
        onSelect: (files) => emit("add-file", files),
      },
    };
    tools.file = {
      class: NoteFileTool,
      config: {
        onSelect: (files) => emit("add-file", files),
      },
    };
  }

  return tools;
}

const editor = ref();

const $toast = useToast();
const converter = ref();

onMounted(() => {
  initEditor();
});

watch(route, () => {
  if (
    !props.description ||
    (typeof props.description !== "string" && !props.description.blocks?.length)
  ) {
    noDescription.value = true;
  } else {
    noDescription.value = false;
  }
  contentLoaded.value = false;
  setTimeout(() => {
    renderDescription();
  }, 500);
});

function initEditor() {
  editor.value = new EditorJS({
    holder: "editorjs",
    tools: getEditorTools(props.from === "user"),
    placeholder: t("Description.description_placeholder"),
    readOnly: !(props.editPermission && canEditKpiTask.value),
    onChange: debounce(() => {
      blockIndex.value = editor.value.blocks.getCurrentBlockIndex();
      try {
        editor.value.save().then((res) => {
          // isChanged.value = JSON.stringify(props.description?.blocks) != JSON.stringify(res?.blocks) ? true : false
          if (
            JSON.stringify(props.description?.blocks) !=
            JSON.stringify(res?.blocks)
          ) {
            saveData();
          }
          if (res !== undefined && res) {
            tempBlock.value = res;
          }
          checkContentSize();
        });
      } catch (error) {
        console.error("ERROR in save: ", error);
      }
    }, 500),
    onReady() {
      document.querySelector(".codex-editor__redactor").style.paddingBottom =
        "10px";
      if (
        !props.description ||
        (Array.isArray(props.description?.blocks) &&
          !props.description.blocks.length)
      ) {
        noDescription.value = true;
      } else if (
        typeof props.description === "string" &&
        props.description !== ""
      ) {
        noDescription.value = false;
      }
      setTimeout(() => {
        renderDescription();
        setupNoteToolboxSections();
      }, 500);
    },
  });
  converter.value = new EditorJS({
    holder: "editor-converter",
    tools: getEditorTools(false),
    onChange() {
      converter.value
        .save()
        .then((newBlocks) => {
          injectBlocks(newBlocks.blocks?.reverse() || []);
        })
        .catch((err) => {
          console.error(err, "Error in conver in to blocks");
        });
    },
  });
}

onBeforeUnmount(() => noteToolboxObserver?.disconnect());

function checkContentSize() {
  contentLoaded.value = true;

  // CHECK IF SIZE EXCEEDS
  const minHeight = 350;
  setTimeout(() => {
    const editorConentHeight =
      document?.querySelector(".codex-editor")?.clientHeight;
    if (!editorConentHeight) return;
    contentExceeds.value = editorConentHeight > minHeight;

    // ADJUST BOTTOM PADDING DEPENDING ON CONTENT SIZE
    const editorTextArea = document.querySelector(".codex-editor__redactor");
    if (editorTextArea) {
      editorTextArea.style.minHeight = "215px";
      if (contentExceeds.value) {
        editorTextArea.style.paddingBottom = "0px";
      } else {
        editorTextArea.style.paddingBottom = "10px";
      }
    }
  });
}

watch(
  () => props.editPermission,
  () => {
    editor.value.readOnly.toggle(!props.editPermission);
  }
);

function blocksToText(response = []) {
  let descText = "";
  response.forEach((x) => {
    switch (x.type) {
      case "file":
        descText += x.data?.name || "File";
        break;
      case "paragraph":
        descText += x.data.text;
        break;
      case "header":
        descText += x.data.text;
        break;
      case "quote":
        descText += x.data.text + "\n";
        descText += x.data.caption;
        break;
      case "warning":
        descText += x.data.title + "\n";
        descText += x.data.message;
        break;
      case "code":
        descText += x.data.code;
        break;
      case "linkTool":
        descText += x.data.link;
        break;
      case "list":
        descText += x.data.items.join(", ");
        break;
      case "checklist":
        descText += x.data.items.map((x) => x.text).join(", ");
        break;
    }
    descText += "\n";
  });
  return descText;
}

function isEmptyFileBlock(block) {
  if (block?.type !== "file") return false;
  const data = block.data || {};
  return !data.id && !data.url && !data.link && !data.href && !data.name;
}

const saveData = debounce(() => {
  editor.value.saver.save().then((response) => {
    response.blocks = response.blocks.filter(
      (block) => block.type !== "WriteWithAi" && !isEmptyFileBlock(block)
    );
    tempBlock.value = response;

    if (props.from === "task" && props.task?.isKpi) {
      const isEmpty =
        !response?.blocks ||
        response.blocks.length === 0 ||
        response.blocks.every((block) => !block.data?.text?.trim());
      if (isEmpty) {
        $toast.error("Description cannot be empty for KPI tasks", {
          position: "top-right",
        });
        if (props.description) {
          if (typeof props.description === "string") {
            blockIndex.value = 1;
            injectDescription(props.description);
          } else {
            editor.value?.render(props.description).then(() => {
              checkContentSize();
            });
          }
        }
        tempBlock.value = props.description || { blocks: [] };
        return;
      }
    }

    if (response) {
      let val = {
        blocks: response || {},
        text: blocksToText(response?.blocks),
      };

      if (props.from === "task") {
        taskClass
          .updateDescription({
            companyId: companyId.value,
            task: props.task,
            text: val,
          })
          .then(() => {
            highlightDescription();
          })
          .catch((error) => {
            $toast.error(t("Toast.Description_not_updated"), {
              position: "top-right",
            });
            console.error("Error in updating Description: ", error);
          });
      } else if (props.from === "user" && props.note?._id) {
        apiRequest("put", `/api/v1/notes/${props.note._id}`, {
          content: tempBlock.value,
          socketId: getters["settings/getSocketInstance"]?.id || "",
        })
          .then((res) => {
            highlightDescription();
            const updatedNote = res?.data?.data || {
              _id: props.note._id,
              content: tempBlock.value,
              title: props.note.title,
            };
            emit("updated", updatedNote);

            const socket = getters["settings/getSocketInstance"];
            const companyId =
              currentCompany.value?._id || currentCompany.value?.id;
            if (socket?.connected && companyId) {
              socket.emit("noteContentChanged", {
                companyId,
                noteId: props.note._id,
              });
            }
          })
          .catch((error) => {
            $toast.error(t("Toast.Description_not_updated"), {
              position: "top-right",
            });
            console.error("Error updating note:", error);
          });
      } else {
        updateProjectDescription(val);
      }
    }
  });
});

function renderDescription(replace = false) {
  try {
    if (props.description) {
      if (typeof props.description === "string") {
        blockIndex.value = 1;
        injectDescription(props.description, replace);
      } else {
        editor.value?.render(props.description).then(() => {
          checkContentSize();
        });
        if (!Object.keys(tempBlock.value).length) {
          tempBlock.value = props.description;
        }
      }
    } else {
      let obj = {
        blocks: [],
      };
      editor.value?.render(obj).then(() => {
        checkContentSize();
      });
    }
  } catch (error) {
    console.error(error, "ERROR:");
  }
}

function renderContent(content) {
  try {
    const nextContent =
      content && typeof content === "object" ? content : { blocks: [] };
    tempBlock.value = nextContent;
    editor.value?.render(nextContent).then(() => {
      checkContentSize();
    });
  } catch (error) {
    console.error(error, "ERROR:");
  }
}

function openDescriptionWithAi() {
  if (!currentCompany.value?.planFeature?.aiPermission) {
    Swal.fire({
      title: t("AI.please_upgrade_plan_to_use_ai"),
      text: t("AI.ai_available_on_paid_plans_upgrade_now"),
      icon: "info",
      confirmButtonColor: "#28C76F",
      confirmButtonText: t("Header.upgrade_now"),
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        router.push({ name: "Upgrade", params: { cid: companyId.value } });
      }
    });
    return;
  }
  const data = {
    query: [{ title: "Write a Description" }],
  };
  apiRequest("post", env.FINDONEPROMPTS, data).then((result) => {
    if (result.data.status === true) {
      selectedPrompt.value = result.data.statusText;
      isOpenPromptDeatil.value = true;
    }
  });
}

async function injectDescription(description = "") {
  try {
    description = description.replaceAll(/\\n/g, "\n");
    const htmlStr = mardownInit.render(description);
    await converter.value.blocks.renderFromHTML(htmlStr);
  } catch (error) {
    console.error(error, "error");
  }
}

async function injectBlocks(newBlocks) {
  const blocks = [...(tempBlock.value?.blocks || [])];

  newBlocks.forEach((block, index) => {
    blocks.splice(blockIndex.value - 1, index === 0 ? 1 : 0, block);
  });
  await editor.value.render({ ...tempBlock.value, blocks });
  checkContentSize();
}

// async function cancelData () {
//     if(Object.keys(tempBlock.value).length > 0){
//         if(props.description){
//             if(typeof props.description === 'string'){
//                 const blockCount = editor.blocks.getBlocksCount();
//                 for (let i = blockCount - 1; i >= 0; i--) {
//                     editor.blocks.delete(i);
//                 }
//                 blockIndex.value = 1;
//                 converter.blocks.renderFromHTML(props.description);
//             }else{
//                 editor?.render(props.description);
//                 if(!Object.keys(tempBlock.value).length){
//                     tempBlock.value = props.description;
//                 }
//             }
//         }else{
//             let obj = {
//                 blocks: []
//             }
//             editor?.render(obj);
//         }
//     }
// }

function resetAiBlocks() {
  // const currIndex = blockIndex.value;
  // editor.blocks.delete(currIndex - 1);

  document.querySelectorAll("[data-type=WW_AI]").forEach((x) => {
    const blockId = x?.parentElement?.parentElement?.dataset?.id;
    const deleteIndex = editor.value.blocks.getBlockIndex(blockId);
    if (deleteIndex >= 0) {
      editor.value.blocks.delete(deleteIndex);
    }
  });
}

function highlightDescription() {
  showMessage.value = true;
  setTimeout(() => {
    showMessage.value = false;
  }, 1000);
}

async function updateProjectDescription(val) {
  let updateObject = { descriptionBlock: val.blocks };
  await apiRequest(
    "put",
    `/api/v1/${env.PROJECTACTIONS}/${props.projectData._id}`,
    { updateObject: updateObject }
  );
  highlightDescription();
  commit("projectData/projectLocalUpdate", {
    itemData: { ...props.projectData, ...updateObject },
    projectId: props.projectData._id,
    key: "RemoveProject",
    subKey: "",
    userId: "",
  });
}
const userId = inject("$userId");
const companyUsers = computed(() => getters["settings/companyUsers"] || []);

const canEditKpiTask = computed(() => {
  return canUserEditKpiTask(props.task, userId.value, companyUsers.value);
});
watch(
  () => [props.editPermission, canEditKpiTask.value],
  () => {
    if (editor.value) {
      editor.value.readOnly.toggle(
        !(props.editPermission && canEditKpiTask.value)
      );
    }
  }
);
provide("injectDescription", injectDescription);

defineExpose({
  highlightDescription,
  renderDescription,
  renderContent,
});
</script>

<style src="./style.css"></style>
